import type { EvProductType } from "@/features/ev/EvProductType";
import type { EvSetType } from "@/features/ev/EvSetType";
import type { Money } from "@/lib/domain/Money";
import { useHTTP, useHTTPQuery } from "@/lib/http";

export interface EvItemBreakdownResponseModel {
	readonly productId: string;
	readonly productName: string;
	readonly fcId: string;
	readonly imageUrl: string;
	readonly currentEstimatedValue: Money;
	readonly warning: string | null;
	readonly categories: EvItemBreakdownResponseModelCategory[];
}

export interface EvItemBreakdownResponseModelCategory {
	readonly category: string;
	readonly categoryName: string;
	readonly multiplier: number;
	readonly averageMarketPrice: Money;
	readonly contributedValue: Money;
}

export const useEvItemsBreakdown = (setType: EvSetType, productType: EvProductType) => {
	const http = useHTTP("Required");
	return useHTTPQuery({
		queryKey: ["evBreakdown", setType, productType],
		queryFn: () => {
			return http<EvItemBreakdownResponseModel>({
				method: "GET",
				url: `/ev/breakdown?setType=${setType}&productType=${productType}`
			});
		}
	});
};
